import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { formatDate } from "src/Common/common";
import ServiceTypeService from "src/Services/API/service.service";

const Archive = () => {
  const [services, setServices] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [restoringId, setRestoringId] = useState(null);

  useEffect(() => {
    getArchivedServices();
  }, []);

  const getArchivedServices = async () => {
    setIsLoading(true);
    try {
      const response = await ServiceTypeService.getAll();
      if (response.status === 200) {
        const data = Array.isArray(response.data) ? response.data : [];
        const archivedServices = data.filter((service) => service?.isActive === false || service?.isArchived === true);
        setServices(archivedServices);
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      console.log("Service type load error: ", error);
      toast(error?.response?.data?.message || "Failed to load archived services");
    } finally {
      setIsLoading(false);
    }
  };

  const handleRestore = async (service) => {
    if (!service?.id) return;
    setRestoringId(service.id);
    try {
      const payload = {
        ...service,
        isActive: true,
      };
      if (payload.isArchived !== undefined) {
        payload.isArchived = false;
      }
      const response = await ServiceTypeService.update(payload);
      if (response.status === 200 || response.status === 201) {
        toast("Service restored successfully");
        getArchivedServices();
      } else {
        toast("Something went wrong");
      }
    } catch (error) {
      console.log("Service type restore error: ", error);
      toast(error?.response?.data?.message || "Failed to restore service");
    } finally {
      setRestoringId(null);
    }
  };

  return (
    <div className="mt-4">
      {isLoading && <p className="text-[12px] font-OpenSansRegular text-subTitleColor">Loading archived services...</p>}
      {!isLoading && services.length === 0 && (
        <p className="text-[12px] font-OpenSansRegular text-subTitleColor">No archived services.</p>
      )}
      {!isLoading && services.length > 0 && (
        <table className="w-full">
          <thead>
            <tr className=" border-b-[1px] border-borderColor">
              <th className="border-r-[1px] border-borderColor">
                <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center px-4 h-[40px] text-titleColor">
                  <span>Name</span>
                </div>
              </th>
              {/* <th className="w-[180px]">
                <div className="font-OpenSansRegular font-[700] text-[12px] flex items-center pl-4 h-[40px] text-titleColor">
                  Archived On
                </div>
              </th> */}
              <th className="w-[120px]"></th>
            </tr>
          </thead>
          <tbody>
            {services.map((service) => (
              <tr key={service.id || service.name} className="border-b-[1px] border-borderColor h-[40px]">
                <td className="border-r-[1px]  border-borderColor">
                  <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                    {service.serviceType}
                  </div>
                </td>
                {/* <td>
                  <div className="font-OpenSansRegular px-[15px] py-[5px] text-[11px] font-[400] col-span-1">
                    {service.archivedAt || service.updatedAt || service.createdAt
                      ? formatDate(service.archivedAt || service.updatedAt || service.createdAt)
                      : "-"}
                  </div>
                </td> */}
                <td>
                  <button
                    type="button"
                    disabled={restoringId === service.id}
                    onClick={() => handleRestore(service)}
                    className="rounded-[6px] bg-blueColor px-3 py-1 text-[11px] font-OpenSansMedium text-white disabled:opacity-60"
                  >
                    {restoringId === service.id ? "Restoring..." : "Restore"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Archive;
